import Vue from 'vue'
import { apiurl, get, post } from './api.js'
import App from './App.vue'
import './plugins/element.js'
import '@/assets/js/iconfont.js'

import { tomoney,elSelectFocus,pwdencode, pwddecode, formatCardNumber, mytrim, addSpace,statusText,examineStatus } from './global.js' // 自定公共函數

import { tify, sify } from 'chinese-conv'; // 簡體和繁體轉換
Vue.prototype.tify = tify; // // 簡體轉繁體
Vue.prototype.sify = sify; // // 繁體轉簡體
Vue.prototype.pwdencode = pwdencode; // // 繁體轉簡體
Vue.prototype.pwddecode = pwddecode; // // 繁體轉簡體
Vue.prototype.tomoney = tomoney; // 數字轉金
Vue.prototype.formatCardNumber = formatCardNumber; // 銀行卡輸入自動增加空格 
Vue.prototype.mytrim = mytrim; // 除去字符串中的空格 
Vue.prototype.addSpace = addSpace; // 需要4位增加空格的字符串
Vue.prototype.statusText = statusText; // 訂單/交易單狀態文字
Vue.prototype.elSelectFocus = elSelectFocus; // 解決select 在ios和ipad無法輸入選擇問題 
Vue.prototype.examineStatus = examineStatus; // 判斷在線審查是否開啟 

Vue.prototype.apiurl = apiurl;
Vue.prototype.get = get;
Vue.prototype.post = post;
Vue.config.productionTip = false
import './asyncroutes.js'
